import styled from 'styled-components/macro';
import px2vw from '../../../utils/px2vw';

export const UniqueOffering = styled.div`
    background: linear-gradient(
        to bottom, 
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 25%, 
        rgba(10, 37, 64, 0.05) 20%,
        rgba(10, 37, 64, 0.05) 100%
    );
    padding-left:  ${props => props.theme.paddingLeft};
    padding-right: ${props => props.theme.paddingRight};
    position: relative;
    @media only screen and (max-width: 425px) {     
        padding-left: 5%;
        padding-right: 5%;
        background: rgba(255, 255, 255, 1);
    }
`;

export const Cards = styled.div`
    display: flex; 
    flex-direction: row; 
    justify-content: space-between; 
    @media only screen and (max-width: 425px) {     
        flex-direction: column; 
        align-items: center;
    }
`;
export const LeftCards = styled.div`
    display: flex; 
    flex-direction: column;    
    background: transparent; 
`;
export const RightCards = styled.div`
    display: flex; 
    flex-direction: column; 
    padding-top:  ${px2vw(80)};    
    @media only screen and (max-width: 425px) {     
        padding-top:  ${px2vw(10)}; 
    }
`;

export const UniqueTitle = styled.div`
    font-family: ${props => props.theme.fontFamily};
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};   
    font-size:  ${props => { 
        return props.theme.mobTitleFontSize?props.theme.mobTitleFontSize:px2vw(24)
    }};    
    font-weight: 700;
    line-height:  ${px2vw(60)};
    letter-spacing: 0px;
    @media only screen and (max-width: 425px) {             font-size: 16px;
             
        line-height:  ${px2vw(24)};
        padding-bottom: 5%;
    }
`;

export const RedBox1 = styled.div`
    width:  ${px2vw(100)};
    height:  ${px2vw(18)};
    top:  ${px2vw(214)};
    left: ${px2vw(-200)};
    position: relative;
    background: #E32C5E;
`;

export const RedBox2 = styled.div`
    width:  ${px2vw(102)};
    height:  ${px2vw(18)};
    top:  ${px2vw(220)};
    left: ${px2vw(-230)};
    position: relative;
    opacity: 0.25;
    background: #E32C5E;
`;
